import type { RouteObject } from "react-router-dom";

// Import all components directly instead of using dynamic imports
import { SignIn } from "@/new-pages/auth/sign-in";
import { ForgotPassword } from "@/new-pages/auth/forgot-password";
import { ResetPassword } from "@/new-pages/auth/reset-password";
import { EmailVerificationConfirm } from "@/new-pages/auth/email-verification-confirm";

export const route: RouteObject = {
	children: [
		{
			path: "sign-in",
			Component: SignIn,
		},
		{
			path: "forgot-password",
			Component: ForgotPassword,
		},
		{
			path: "reset-password",
			Component: ResetPassword,
		},
		{
			path: "confirm-email",
			Component: EmailVerificationConfirm,
		},
	],
};
